module.exports = {"320826001":"涟城街道","320826002":"朱码街道","320826003":"陈师街道","320826004":"保滩街道","320826101":"高沟镇","320826102":"唐集镇","320826104":"大东镇","320826105":"五港镇","320826106":"梁岔镇","320826107":"石湖镇","320826109":"岔庙镇","320826110":"东胡集镇","320826111":"南集镇","320826113":"成集镇","320826114":"红窑镇","320826117":"黄营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320826.json
// module id = 999
// module chunks = 0